import { BaseError } from './base';

type NoWalletProviderFoundErrorParams = {
  walletProviderKey: string;
};

export class NoWalletProviderFoundError extends BaseError {
  constructor({ walletProviderKey }: NoWalletProviderFoundErrorParams) {
    super({
      cause: null,
      code: 'no_wallet_provider_found_error',
      docsUrl: null,
      name: 'NoWalletProviderFoundError',
      shortMessage: `No wallet provider found with key: ${walletProviderKey}`,
    });
  }
}
